<template>
  <div class="StoriesPreview">
    <div class="chapters">
      <div class="chapter" v-for="(chapter, key) in chapters" :key="key">
        <h3>{{ chapter.title }}</h3>
        <span v-html="chapter.text"></span>
      </div>
      <router-link :to="{ name: 'stories-edit', params: { id: $route.params.id } }">
        <button class="back">Назад</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import stories from "@/composables/views/stories.ts";

export default {
  name: "StoriesPreview",
  setup() {
    const {
      getStory,
      title,
      shortDescription,
      description,
      text,
      author,
      status,
      ImageTitle,
      chapters,
    } = stories();

    return {
      getStory,
      title,
      shortDescription,
      description,
      text,
      author,
      status,
      ImageTitle,
      chapters,
    };
  },
  async created() {
    this.getStory(true);
  },
};
</script>